import moment from 'moment'
import i18n from '@/lang/i18n'
import { NumberFormatOptions } from 'vue-i18n'
import { isNil } from 'lodash'

export type FilterDate = Date | string | number

export class Formatter {
    /// STRING ///

    public static lowercase(value?: string): string {
        return value ? value.toLowerCase() : ''
    }

    public static uppercase(value?: string): string {
        return value ? value.toUpperCase() : ''
    }

    public static capitalize(value: string): string {
        if (value) {
            const result = Formatter.lowercase(value)
            return Formatter.uppercase(result.charAt(0)) + result.slice(1)
        }
        return ''
    }

    public static removeAccents(value: string): string {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    }

    /// DATE ///

    public static ago(value?: FilterDate): string {
        return value ? moment(value).fromNow() : ''
    }

    public static date(value?: FilterDate): string {
        if (value) {
            if (value === '-') {
                return value
            }
            return moment(value).format('L')
        }
        return ''
    }

    public static datetime(value?: FilterDate): string {
        if (value) {
            if (value === '-') {
                return value
            }
            return moment(value).format('L HH:mm')
        }
        return ''
    }

    /// NUMBER ///

    /**
     * Represents a given integer number in <em>base alphabet</em>.
     *
     * A number represented in <em>base alphabet</em> uses as digits the letters of the alphabet, from A to Z,
     * where 0 is represented as A, 25 as Z, 26 as AA, 27 as AB, and so on.
     */
    public static baseAlphabetFilter(value: number): string {
        const base = 26
        const letterACharCode = 65
        let baseAlphabetNumber = ''
        let remainingBase10Number = value + 1
        do {
            remainingBase10Number--
            baseAlphabetNumber = String.fromCharCode((remainingBase10Number % base) + letterACharCode) + baseAlphabetNumber
            remainingBase10Number = Math.floor(remainingBase10Number / base)
        } while (remainingBase10Number > 0)
        return baseAlphabetNumber
    }

    public static get decimalFormatOptions(): NumberFormatOptions {
        return {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }
    }

    public static number(
        value?: number | string,
        numberFormat = false,
        numberFormatOptions = Formatter.decimalFormatOptions
    ): string {
        let _value: number | undefined
        if (typeof value === 'string') {
            _value = parseFloat(value)
        } else {
            _value = value
        }

        let _format: NumberFormatOptions | undefined
        if (numberFormat) {
            _format = numberFormatOptions
        }

        return !isNil(_value) ? i18n.n(_value, _format) : ''
    }
}
